import $ from 'jquery'
import IMask from 'imask'

export default () => {
    $('form input[type="email"]').on('keyup change', () => {
        let input = $(this)

        input.val(input.val().replace(/\s+/g, ''))
    })

    let telInput = $('input[type="tel"]')
    if (telInput.length > 0){
        let phoneMask = IMask(
            telInput.get(0), {
                mask: '0000000000'
            }
        )
    }




}
